import React, { useEffect, useState } from 'react';


function HelpLinkProperties(props: any) {
  return (<>{"HelpLink"}</>)
}

export default HelpLinkProperties